export default __webpack_public_path__ + "static/media/background.e8ddf640.jpg";